module.exports = __webpack_public_path__ + "static/media/ic-cus-list-none.644a0f92.svg";